import $ from 'jquery';
import Swal from 'sweetalert2';
import { tr, lang } from '../../utils/helpers';

export const hours = () => {
  const $form = document.getElementById('form-report');
  const $total_time_planning = document.querySelector('[name="total_time_planning"]');
  const $total_time_action = document.querySelector('[name="total_time_action"]');

  $form.addEventListener('submit', e => {
    if ($total_time_planning.value.length < 5 || $total_time_action.value.length < 5) {
      e.preventDefault();
      Swal.fire(tr[lang].modal_error_attention, tr[lang].modal_error_hours, 'error');
    } else {
      if ($total_time_planning.value.split(':')[1] > 59 || $total_time_action.value.split(':')[1] > 59) {
        e.preventDefault();
        Swal.fire(tr[lang].modal_error_attention, tr[lang].modal_error_minutes, 'error');
      }
    }
  });
};
